/* Smooth (AJAX) filtering for the collection grid.
   Intercepts filter/pill/pagination links and the sort/filter forms,
   fetches the target URL, and cross-fades the refreshed section in
   place instead of a hard page reload. Falls back to normal
   navigation on any error or when JS is unavailable. */
(function () {
  function initCollection(section) {
    if (!section || section.__bsAjaxFilters) return;
    section.__bsAjaxFilters = true;

    var desktopQuery = window.matchMedia('(min-width: 990px)');

    function groupName(details) {
      var label = details.querySelector('summary span');
      return label ? label.textContent.replace(/\(\d+\)/, '').replace(/\s+/g, ' ').trim() : '';
    }

    function openGroupNames() {
      return Array.prototype.slice.call(section.querySelectorAll('.bs-filter-group'))
        .filter(function (details) { return details.open; })
        .map(groupName);
    }

    function currentDrawer() {
      return section.querySelector('[data-bs-filters-drawer]');
    }

    function unbindInlineSort() {
      var sort = section.querySelector('.bs-collection__sort');
      if (sort) sort.onchange = null;
    }

    function afterSwap(openNames, drawerWasOpen) {
      Array.prototype.slice.call(section.querySelectorAll('.bs-filter-group')).forEach(function (details) {
        if (openNames.indexOf(groupName(details)) !== -1) details.open = true;
      });
      var drawer = currentDrawer();
      if (drawer) {
        if (desktopQuery.matches || drawerWasOpen) {
          drawer.setAttribute('open', '');
        } else {
          drawer.removeAttribute('open');
        }
      }
      unbindInlineSort();
    }

    var activeRequest = 0;

    function swap(url, push) {
      var requestId = ++activeRequest;
      section.classList.add('bs-collection--loading');
      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Filter fetch failed');
          return response.text();
        })
        .then(function (html) {
          if (requestId !== activeRequest) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('section.bs-collection');
          if (!fresh) throw new Error('Section missing in response');

          var openNames = openGroupNames();
          var drawer = currentDrawer();
          var drawerWasOpen = drawer ? drawer.open : false;

          section.innerHTML = fresh.innerHTML;
          afterSwap(openNames, drawerWasOpen);

          if (doc.title) document.title = doc.title;
          if (push) history.pushState({ bsCollectionFilters: true }, '', url);

          window.requestAnimationFrame(function () {
            section.classList.remove('bs-collection--loading');
          });
        })
        .catch(function () {
          window.location.href = url;
        });
    }

    function buildFormUrl(form) {
      var params = new URLSearchParams(new FormData(form));
      var pairs = [];
      params.forEach(function (value, key) {
        if (value !== '') pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return window.location.pathname + (pairs.length ? '?' + pairs.join('&') : '');
    }

    section.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      var link = event.target.closest('a[href]');
      if (!link || !section.contains(link)) return;

      var isFilterLink = link.classList.contains('bs-check--link')
        || link.classList.contains('bs-collection__clear')
        || !!link.closest('.bs-collection__active-tags')
        || !!link.closest('.bs-collection__pagination')
        || !!link.closest('.bs-collection__empty');
      if (!isFilterLink) return;

      event.preventDefault();
      var inPagination = !!link.closest('.bs-collection__pagination');
      swap(link.getAttribute('href'), true);
      if (inPagination) {
        var main = section.querySelector('.bs-collection__main');
        if (main) {
          var top = main.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      }
    });

    section.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.id !== 'CollectionFiltersForm') return;
      event.preventDefault();
      swap(buildFormUrl(form), true);
    });

    section.addEventListener('change', function (event) {
      if (!event.target.classList.contains('bs-collection__sort')) return;
      var form = event.target.form;
      if (!form) return;
      event.preventDefault();
      swap(buildFormUrl(form), true);
    });

    function applyCheckerRank() {
      if (!/[?&]bs_ranked=1/.test(window.location.search)) return;
      var payload = null;
      try {
        payload = JSON.parse(window.sessionStorage.getItem('blusafeCheckerRank') || 'null');
      } catch (error) {
        return;
      }
      var handles = payload && payload.handles;
      if (!handles || !handles.length) return;

      var grid = section.querySelector('.bs-collection__grid');
      if (!grid) return;

      function handleOf(card) {
        var link = card.matches && card.matches('a[href*="/products/"]') ? card : card.querySelector && card.querySelector('a[href*="/products/"]');
        var match = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
      }

      var cards = Array.prototype.slice.call(grid.children).filter(function (child) {
        return handleOf(child) !== '';
      });
      if (!cards.length) return;

      var ranked = cards.slice().sort(function (a, b) {
        var indexA = handles.indexOf(handleOf(a));
        var indexB = handles.indexOf(handleOf(b));
        if (indexA === -1) indexA = handles.length;
        if (indexB === -1) indexB = handles.length;
        return indexA - indexB;
      });
      ranked.slice().reverse().forEach(function (card) {
        grid.insertBefore(card, grid.firstChild);
      });

      var best = ranked[0];
      if (best && handles.indexOf(handleOf(best)) === 0) {
        var badges = best.querySelector('.bs-card__badges');
        if (badges) {
          var badge = document.createElement('span');
          badge.className = 'bs-badge bs-badge--best-match';
          badge.textContent = 'Best match';
          badges.insertBefore(badge, badges.firstChild);
        }
      }

      var bar = section.querySelector('.bs-collection__results-bar');
      if (bar && !bar.querySelector('.bs-collection__rank-note')) {
        var note = document.createElement('span');
        note.className = 'bs-collection__rank-note';
        note.textContent = 'Ordered by best match for your door';
        bar.appendChild(note);
      }
    }

    window.addEventListener('popstate', function (event) {
      if (event.state && event.state.bsCollectionFilters) {
        swap(window.location.href, false);
      } else if (history.state === null && document.querySelector('section.bs-collection')) {
        swap(window.location.href, false);
      }
    });

    desktopQuery.addEventListener('change', function () {
      var drawer = currentDrawer();
      if (!drawer) return;
      if (desktopQuery.matches) {
        drawer.setAttribute('open', '');
      } else {
        drawer.removeAttribute('open');
      }
    });

    unbindInlineSort();
    applyCheckerRank();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('section.bs-collection')).forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
